import { Box } from "@mui/material";
import { ProjectsCard } from "./ProjectsCard";

function Projects() {
  return (
    <Box>
      <ProjectsCard />
    </Box>
  );
}

export default Projects;
